import { Inject, Injectable } from '@angular/core';
import { SubscriptionTiersService } from '@galaxy/partner';
import { IAMService, UserInterface } from '@vendasta/iam';
import { combineLatest, Observable } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { AppConfigService } from '../app-config.service';
import { PartnerService } from '../core/partner.service';

export interface PLGUsage {
  productsUsed: number;
  productMax: number;
}

export interface CardConfig {
  id: string;
  show: boolean;
  learnMoreExpanded: boolean;
}

@Injectable()
export class DashboardService {
  constructor(
    private readonly partnerService: PartnerService,
    private readonly appConfigService: AppConfigService,
    private iamService: IAMService,
    @Inject('USER_ID') private userId$: Observable<string>,
  ) {}

  getCurrentUser(): Observable<UserInterface> {
    return this.userId$.pipe(
      switchMap((userId) => {
        return this.iamService.getMultiUsers([{ userId: userId }]);
      }),
      map((users) => (!!users && users.length > 0 ? users[0] : null)),
    );
  }

  getIsFree(): Observable<boolean> {
    return this.partnerService.subscriptionTier$.pipe(map((s) => SubscriptionTiersService.isFree(s)));
  }

  getCardConfig$(): Observable<CardConfig[]> {
    return combineLatest([this.appConfigService.config$, this.getIsFree()]).pipe(
      map(([ac, isFree]) => {
        let cards: CardConfig[];
        if (isFree) {
          cards = [
            {
              id: 'addToolkits',
              show: ac.userCanAccessAccounts,
              learnMoreExpanded: true,
            },
            {
              id: 'addBusinessesAccounts',
              show: ac.userCanAccessAccounts,
              learnMoreExpanded: false,
            },
            {
              id: 'createSnapshotReports',
              show: ac.userCanAccessAccounts,
              learnMoreExpanded: false,
            },
          ];
        } else {
          cards = [
            {
              id: 'addBusinessesAccounts',
              show: ac.userCanAccessAccounts,
              learnMoreExpanded: false,
            },
            {
              id: 'createSnapshotReports',
              show: ac.userCanAccessAccounts,
              learnMoreExpanded: false,
            },
            {
              id: 'addToolkits',
              show: ac.userCanAccessAccounts,
              learnMoreExpanded: false,
            },
          ];
        }
        return cards;
      }),
    );
  }

  getUserFirstName(): Observable<string> {
    return this.appConfigService.config$.pipe(map((config) => config.userFirstName));
  }
}
